export default "__VITE_ASSET__0d70029b__"